module.exports = __webpack_public_path__ + "img/九玄男.40b401b7.png";